__turbopack_context__.v({
  "card": "GreyCards-module__z24sQW__card",
  "cta": "GreyCards-module__z24sQW__cta",
  "description": "GreyCards-module__z24sQW__description",
  "wrapper": "GreyCards-module__z24sQW__wrapper",
});
